import { Strip, Wrapper } from './view';

interface AudioBarsProps {
    animated?: boolean;
    count?: number;
    color?: string;
}

export const AudioBars = ({ animated = true, count = 5, color }: AudioBarsProps) => {
    return (
        <Wrapper $color={color}>
            {Array.from({ length: count }, (_, i) => (
                <Strip key={i} $isOdd={i % 2 === 0} $animated={animated} $delay={i * 0.2} />
            ))}
        </Wrapper>
    );
};

AudioBars.displayName = 'AudioBars';
